export const TabsPlaceholder = () => (
    <div className="placeholder-glow d-flex gap-2">
        <div style={{ width: 100 }} className="placeholder py-3 bg-primary rounded-pill col-3"></div>
        <div
            style={{ width: 100 }}
            className="placeholder py-3 bg-secondary border border-white rounded-pill col-3"
        ></div>
        <div
            style={{ width: 100 }}
            className="placeholder py-3 bg-secondary border border-white rounded-pill col-3"
        ></div>
    </div>
);
